module.exports = __webpack_public_path__ + "img/slide-14-1.60907a84.jpg";